export const colorNeutral = '#ffffff';
export const colorMediumGrey = '#d6d6d6';
export const colorSecondary050 = '#faf9f9';
export const colorSecondary100 = '#f2f1f1';
export const colorSecondary200 = '#d9d6d7';
export const colorSecondary300 = '#bdb9ba';
export const colorSecondary400 = '#c3c2c2';
export const colorSecondary800 = '#3e3435';
export const colorSecondary900 = '#302322';
export const colorNeutral900 = '#171616';
export const colorPrimary500 = '#e03127';
export const colorGuidance400 = '#67b2c7';
export const colorGuidance500 = '#017ea1';
export const colorGuidance700 = '#015871';
export const colorGuidance800 = '#003f50';
export const colorSpinner = '#f3f3f3';
export const colorBorder = '#f4f4f4';
export const colorCommonRed80 = '#cA3629';
export const colorCommonRed190 = '#ffeceb';
export const colorCommonBlue80 = '#2572cc';
export const colorCommonBlue190 = '#eaf4ff';
export const colorPlaceholder = '#eff1f2';
